import { ChangeDetectorRef, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { LoaderState } from './loader';
import { LoaderService } from './loader.service';


@Component({
   selector: 'app-loader',
   templateUrl: 'loader.component.html',
   styleUrls: ['loader.component.css']
})
export class LoaderComponent implements OnInit, OnDestroy {

   show = false;

   @Input()
   image: string = '/img/spinner.gif';
   private subscription: Subscription;

   constructor(private loaderService: LoaderService,
      private cdRef: ChangeDetectorRef) { }

   ngOnInit() {
      this.subscription = this.loaderService.loaderState
         .subscribe((state: LoaderState) => {
            this.show = state.count > 0;
            this.cdRef.detectChanges();
         });
   }

   ngOnDestroy() {
      this.subscription.unsubscribe();
   }
}
